import {
  Component
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReactiveFormsModule
} from '@angular/forms';

import {
  MatDatepickerModule
} from '@angular/material/datepicker';

import {
  MatInputModule
} from '@angular/material/input';

import {
  MatNativeDateModule
} from '@angular/material/core';

import { LineCellBaseComponent }
from '../line-cell-base/line-cell-base.component';

@Component({
  selector: 'app-line-cell-date',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule
  ],

  templateUrl: './line-cell-date.component.html'
})
export class LineCellDateComponent
extends LineCellBaseComponent {
}